<template>
<div class="full-wrapper service-operation-comp">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full" :style="activeTabName == 'map' ? 'height: 100%;' : ''">
      <el-tabs class="tab-button" v-model="activeTabName" @tab-click="changeActiveTab" style="height: 100%;">
        <!-- 중요 프로세스 -->
        <el-tab-pane :label="tabs.process.label" :name="tabs.process.name" :key="tabs.process.name">
          <w-service-major-process-list :ref="tabs.process.name" :active="tabs.process.active"></w-service-major-process-list>
        </el-tab-pane>
        <!-- 서비스 포트 -->
        <el-tab-pane :label="tabs.port.label" :name="tabs.port.name" :key="tabs.port.name">
          <w-service-major-port-list :ref="tabs.port.name" :active="tabs.port.active"></w-service-major-port-list>
        </el-tab-pane>
        <!-- 로그  -->
        <el-tab-pane :label="tabs.log.label" :name="tabs.log.name" :key="tabs.log.name">
          <w-service-log-list :ref="tabs.log.name" :active="tabs.log.active"></w-service-log-list>
        </el-tab-pane>
        <!-- 서비스맵 -->
        <el-tab-pane v-if="mapInfoList.length" style="height: 100%;" :label="tabs.map.label" :name="tabs.map.name" :key="tabs.map.name">
          <w-service-map v-if="mapInfoList.length" :ref="tabs.map.name" :active="tabs.map.active" style="height: 100%;"></w-service-map>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import WPerformanceServerAnalysisTable from '@/views/performance/node/analysis/server/PerformanceServerAnalysisTable';
import ServiceApi from '@/api/performance/service/service';
import WServiceLogList from './components/ServiceLogList';
import WServiceMajorPortList from './components/ServiceMajorPortList';
import WServiceMajorProcessList from './components/ServiceMajorProcessList';
import WServiceMap from './components/ServiceMap';

export default {
  name: 'WPerformanceServiceOperation',
  mixins: [ScrollbarMixin],
  components: {
    WPerformanceServerAnalysisTable,
    WServiceLogList,
    WServiceMajorPortList,
    WServiceMajorProcessList,
    WServiceMap,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      activeTabName: '',
      activeTab: null,
      tabs: {
        process: {
          name: 'process',
          label: '중요 프로세스',
          active: false,
        },
        port: {
          name: 'port',
          label: '서비스 포트',
          active: false,
        },
        log: {
          name: 'log',
          label: '로그',
          active: false,
        },
        map: {
          name: 'map',
          label: '서비스맵',
          active: false,
        },
      },
      mapInfoList: [],
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  mounted() {
    this.setScrollData();
    this.activeTabName = this.tabs.process.name;
    this.loadMapInfoList();
    this.changeActiveTab();
  },
  watch: {
    selectedNode: {
      handler(node) {
        if (node && this.active) {
          this.loadMapInfoList();
          this.$refs[this.activeTab.name].loadData();
        }
      },
    },
    active: {
      handler(flag) {
        if (flag) {
          this.loadMapInfoList();
          this.$refs[this.activeTab.name].loadData();
        }
      },
    },
    /**
     * 서비스맵 탭 표출 판단용 - 서비스맵이 있는 대상에서 없는 대상으로 화면이 전환 시 탭 정보를 변경한다.
     * @author Song
     */
    mapInfoList: {
      handler(data) {
        if (data.length === 0 && this.activeTabName !== this.tabs.process.name) {
          const preActiveTabeName = cloneDeep(this.activeTabName);
          this.activeTabName = preActiveTabeName === this.tabs.map.name ? this.tabs.process.name : preActiveTabeName;

          if (preActiveTabeName === this.tabs.map.name) {
            this.changeActiveTab();
          }
        }
      },
    },
  },
  methods: {
    changeActiveTab() {
      const activeTab = this.tabs[this.activeTabName];
      activeTab.active = true;
      if (!isNil(this.activeTab)) {
        this.activeTab.active = false;
      }
      this.activeTab = activeTab;
    },
    /**
     * 서비스 관리대상에 해당하는 mapId 리스트를 조회한다.
     */
    loadMapInfoList() {
      if (!this.active) {
        return;
      }
      ServiceApi.getServiceMapInfoList({ objId: this.selectedNode.obj.objId }).then((res) => {
        if (res.data.success) {
          this.mapInfoList = res.data.data;
        }
      });
    },
  },
};
</script>

<style>
  .service-operation-comp .el-scrollbar__view {
    height: calc(100% - 25px);
  }
  .service-operation-comp .el-tabs__content {
    height: calc(100% - 30px);
    padding-top: 0px !important;
  }
  .service-operation-comp .el-tabs__header {
    height: 30px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/performance/node/operation/service/index.vue